import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import { api, formatApiErrorDetail } from "../lib/api";

const AdminLogin = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (localStorage.getItem("spinlab_token")) {
    return <Navigate to="/admin/leads" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("spinlab_token", data.token);
      localStorage.setItem("spinlab_user", JSON.stringify(data.user));
      toast.success("Welcome back.");
      nav("/admin/leads");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-black flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-12">
          <Logo size="md" testId="admin-login-logo" />
        </div>
        <div className="hairline w-full mb-10" />
        <h1 className="text-center text-2xl font-display font-extralight uppercase tracking-[0.3em] text-white mb-2">
          Admin Access
        </h1>
        <p className="text-center text-[10px] font-display font-light uppercase tracking-[0.4em] text-gray-500 mb-12">
          Authorized personnel only
        </p>

        <form data-testid="admin-login-form" onSubmit={onSubmit} className="space-y-10">
          <label className="block">
            <span className="block text-[10px] font-display font-light uppercase tracking-[0.4em] text-gray-500 mb-3">
              Email
            </span>
            <input
              data-testid="admin-login-email"
              type="email"
              required
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              className="w-full bg-transparent border-0 border-b border-gray-800 rounded-none px-0 py-3 text-sm text-white placeholder:text-gray-700 focus:outline-none focus:border-white transition-colors"
              placeholder="admin@spinlab.com"
            />
          </label>
          <label className="block">
            <span className="block text-[10px] font-display font-light uppercase tracking-[0.4em] text-gray-500 mb-3">
              Password
            </span>
            <input
              data-testid="admin-login-password"
              type="password"
              required
              value={form.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
              className="w-full bg-transparent border-0 border-b border-gray-800 rounded-none px-0 py-3 text-sm text-white placeholder:text-gray-700 focus:outline-none focus:border-white transition-colors"
              placeholder="••••••••"
            />
          </label>

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full px-8 py-4 border border-gray-300 text-[11px] font-display font-light uppercase tracking-[0.3em] text-white hover:bg-white hover:text-black transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
